// extracted by mini-css-extract-plugin
export default {"carousel":"P5","ingredient":"Q5","swiper-pagination-bullet":"R5","swiper-pagination-bullet-active":"S5","swiper_carousel":"T5","swiper_pagination":"U5","arrows":"V5","arrow_navigation":"W5"};
    if(module.hot) {
      // 1715188240141
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  